<template>
  <div class="img-bc">
    <div v-if="!src" class="defaultImage" :style="{width:width + 'px',height:height + 'px'}">
      <img :src="defaultImg" :style="{width:width + 'px',height:height + 'px'}">
    </div>
    <img class="image" v-if="src" :style="{width:width + 'px',height:height + 'px'}"
      :src="src?src+'?x-oss-process=image/'+type+',' + way + ',h_'+height+',w_'+width:defaultImg" :onerror="imageError"
      :alt="alt">
    <!-- <img class="image" v-if="src && way==='m_fill'" :style="{width:width + 'px',height:height + 'px'}"
      :src="src?src+'?x-oss-process=image/'+type+',' + way + ',h_'+height+',w_'+width+',limit_0':defaultImg"
      :onerror="imageError" :alt="alt">

    <img class="image" v-if="src && way==='m_pad'" :style="{width:width + 'px',height:height + 'px'}"
      :src="src?src+'x-oss-process=image/' + width + 'w_' + height + 'h_4e':defaultImg" :onerror="imageError" :alt="alt"> -->

  </div>
</template>

<script>
  export default {
    name: 'abImg',
    components: {},
    props: {
      way: {
        type: String,
        required: false,
        default: 'm_fill'
      },
      src: {
        required: false,
        default: ''
      },
      alt: {
        type: String,
        required: false,
        default: ''
      },
      type: {
        type: String,
        required: false,
        default: 'resize'
      },
      width: {
        type: [Number, String],
        required: false,
        default: 100
      },
      height: {
        type: [Number, String],
        required: false,
        default: 75
      }
    },
    data() {
      return {
        defaultImg: require('@/assets/images/default-img.jpg'),
        isShowDefault: false
      };
    },
    methods: {
      imageError() {
        this.src = this.defaultImg
      },
    }
  }

</script>

<style lang="scss" scoped>
  .defaultImage {
    position: relative;
    overflow: hidden;

    .img-bc {
      width: 100%;
    }

    image {
      display: block;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      margin: auto;
    }
  }

  .image {
    display: block;
  }

</style>



// WEBPACK FOOTER //
// src/components/abImg.vue